import React from 'react';
import DashboardDonutChart from './DashboardDonutChart';
import DashboardBarChart from './DashboardBarChart';
import DashboardRadialChart from './DashboardRadialChart';
import DashboardPolarChart from './DashboardPolarChart';
import DashboardAreaChart from './DashboardAreaChart';
import DashboardPieChart from './DashboardPieChart';
import { getAccentColor } from '../../dashboardChartColors';

const CHART_COMPONENTS = {
    donut: DashboardDonutChart,
    bar: DashboardBarChart,
    'bar-horizontal': DashboardBarChart,
    radial: DashboardRadialChart,
    polar: DashboardPolarChart,
    area: DashboardAreaChart,
    pie: DashboardPieChart,
};

function DashboardChartCard({ chart, compact = false, chartIndex = 0 }) {
    const ChartComponent = CHART_COMPONENTS[chart.type] || DashboardDonutChart;
    const isHorizontal = chart.type === 'bar-horizontal';
    const accentColor = getAccentColor(chartIndex, chart.accent);

    return (
        <div className={`dashboard-chart-card ${compact ? 'dashboard-chart-card--compact' : ''}`}>
            <div
                className="dashboard-chart-card__glow"
                style={{ background: accentColor }}
                aria-hidden="true"
            />
            <div className="dashboard-chart-card__header">
                <div
                    className="dashboard-chart-card__accent"
                    style={{ background: accentColor }}
                />
                <div>
                    <h6 className="dashboard-chart-card__title mb-0">{chart.title}</h6>
                    {chart.subtitle && (
                        <p className="dashboard-chart-card__subtitle mb-0">{chart.subtitle}</p>
                    )}
                </div>
                {chart.icon && (
                    <span
                        className="dashboard-chart-card__icon"
                        style={{ background: `${accentColor}22`, color: accentColor }}
                        aria-hidden="true"
                    >
                        <i className={`bi ${chart.icon}`} />
                    </span>
                )}
            </div>
            <div className="dashboard-chart-card__body">
                <ChartComponent
                    series={chart.series}
                    horizontal={isHorizontal || chart.horizontal}
                    percentage={chart.percentage}
                    stacked={chart.stacked}
                    title={chart.title}
                />
            </div>
        </div>
    );
}

export default DashboardChartCard;
